import { Component, OnInit } from '@angular/core';
import { Article } from 'src/app/modules/entities/article';
import { ArticleService } from 'src/app/modules/services/article.service';

@Component({
  selector: 'app-read-article',
  templateUrl: './read-article.component.html',
  styleUrls: ['./read-article.component.css']
})
export class ReadArticleComponent implements OnInit {

  constructor (private articleService: ArticleService) { }

  article: Article | undefined;

  ngOnInit(): void {
    this.articleService.getArticle()
  }

}
